import { isEmpty } from 'lodash';

import { DASHBOARD_DATA_SETS } from 'constants/dashboard';
import { getOrdinalNumber } from 'helper/getOrdinalNumber';

const DATA_SETS_LABELS = {
  [DASHBOARD_DATA_SETS.CURRENT_DATA_SET]: 'Current Data Set',
  [DASHBOARD_DATA_SETS.PREVIOUS_DATA_SET]: 'Previous Data Set',
  [DASHBOARD_DATA_SETS.ALL_DATA_SETS]: 'All Data Sets',
  [DASHBOARD_DATA_SETS.CUSTOM]: 'Custom Range',
};

const getDataSetOption = (dataSetKey, dataSetValue = null) => ({
  label: DATA_SETS_LABELS[dataSetKey],
  value: dataSetValue || dataSetKey,
});

export const getDataSetsList = (dataSets, withCustomRange = false) => {
  if (isEmpty(dataSets) || isEmpty(dataSets.current_dataset_date)) {
    return [];
  }

  const dataSetsKeysLength = Object.keys(dataSets).length;
  const { other_dataset_dates: otherDataSets = [], previous_dataset_date: previousDataSet } = dataSets;

  const currentDataSetOption = getDataSetOption(DASHBOARD_DATA_SETS.CURRENT_DATA_SET);
  const previousDataSetOption = previousDataSet ? getDataSetOption(DASHBOARD_DATA_SETS.PREVIOUS_DATA_SET) : null;
  const allDatasetOption = previousDataSet ? getDataSetOption(DASHBOARD_DATA_SETS.ALL_DATA_SETS) : null;
  const customRangeOption =
    dataSetsKeysLength > 2 && withCustomRange ? getDataSetOption(DASHBOARD_DATA_SETS.CUSTOM) : null;

  const otherDataSetsOptions = otherDataSets
    .map((value, index) => {
      const dataSetNumber = index + 1;

      return {
        label: `${getOrdinalNumber(dataSetNumber)} Data Set`,
        value: index,
      };
    })
    .toReversed();

  return [
    currentDataSetOption,
    ...(previousDataSetOption ? [previousDataSetOption] : []),
    ...otherDataSetsOptions,
    ...(allDatasetOption ? [allDatasetOption] : []),
    ...(customRangeOption ? [customRangeOption] : []),
  ];
};
